// Re-export all IAP types and service for web platform
export * from './iapService.web';
export { iapService } from './iapService.web';

